import { createFileRoute, useSearch } from '@tanstack/react-router'
import { requireAuthBeforeLoad } from '@/features/auth/guards'
import { AppShell } from '@/features/app-shell/app-shell'
import { HomeCanvas } from '@/features/app-shell/canvases/home-canvas'

type AppSearch = {
  'project-type'?: 'clip' | 'caption'
}

export const Route = createFileRoute('/app/')({
  validateSearch: (search: Record<string, unknown>): AppSearch => ({
    'project-type':
      search['project-type'] === 'caption'
        ? 'caption'
        : search['project-type'] === 'clip'
          ? 'clip'
          : undefined,
  }),
  beforeLoad: ({ location }) => requireAuthBeforeLoad({ location }),
  component: AppHomePage,
})

function AppHomePage() {
  const search = useSearch({ from: '/app/' })
  const projectType = search['project-type']

  return (
    <AppShell activePath="/app">
      <HomeCanvas projectType={projectType} />
    </AppShell>
  )
}
